import actionTypes from 'SRC/modules/redux/actionTypes'

export const updateServiceProviderPhotoById = (id, photo) => ({
  type: actionTypes.UPDATE_SERVICE_PROVIDER_PHOTO_BY_ID,
  payload: {id, photo}
})
